export default __webpack_public_path__ + "static/logo-14-4b53f90a5e9374c17b0f4afc8b928b56.png";